import React, { useState } from "react";
import Modal from "./index";
import { resetSnakeDay } from "../../utils/localStorage";
import Button from "../Button";
import bugReport from "../../api/bugReport";

export default function HelpModal({ show, onClose, onWatchTutorial }) {
    const [showBugReport, setShowBugReport] = useState(false);
    const [message, setMessage] = useState("");

    const resetDaysPuzzle = () => {
        resetSnakeDay();
        setTimeout(() => {
            window.location.reload();
        }, 0);
    };

    return (
        <Modal show={show} onClose={onClose}>
            <div style={{ padding: "20px", fontFamily: "Arial, sans-serif", color: "#ccc", textAlign: "center" }}>
                <h1 style={{ color: "#ccc", marginBottom: 8 }}>CineSnake</h1>
                <p style={{ lineHeight: "1.6", marginBottom: 24 }}>
                    Connect the head to the tail by alternating actors and movies.
                    Build from either end, avoid wrong guesses, and chain your way to the finish.
                    <span onDoubleClick={resetDaysPuzzle} style={{ cursor: "pointer" }}> 🎬</span>
                </p>
                <div style={{ display: "flex", gap: "10px", justifyContent: "center", marginBottom: 20 }}>
                    <Button onClick={onWatchTutorial} text={"See Tutorial"} />
                    <Button onClick={() => setShowBugReport(b => !b)} text={"Report a Bug"} />
                </div>
                {showBugReport && (
                    <div style={{ marginTop: 10 }}>
                        <textarea
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            placeholder="Describe the bug..."
                            style={{
                                width: "100%",
                                height: "100px",
                                padding: "10px",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                fontSize: "14px",
                                resize: "none",
                                boxSizing: "border-box",
                            }}
                        />
                        <Button
                            onClick={() => {
                                bugReport(message);
                                setMessage("Thank you for making this game better.");
                            }}
                            text={"Send Bug Report"}
                        />
                    </div>
                )}
            </div>
        </Modal>
    );
}
